import { useMemo } from "react"

import type { RunMetricOutput } from "@/types/RunMetricOutput"

export const AggregateOverviewFloat = ({
  mos,
  units,
}: {
  mos: RunMetricOutput[]
  units: string
}) => {
  const average = useMemo(() => {
    const valid = mos.filter((m) => m.float_value !== null)
    if (valid.length === 0) {
      return null
    }
    return (
      valid.map((m) => m.float_value as number).reduce((a, b) => a + b, 0) /
      valid.length
    )
  }, [mos])

  if (average === null) {
    return null
  }
  return (
    <div className="text-4xl text-coval-text mb-1 font-bold">
      {average.toFixed(2)}
      <span className="text-sm font-medium mx-1">{units}</span>
    </div>
  )
}
